var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"display-flex-align-center",attrs:{"id":"custom-icon-component"}},[(_vm.isCustomIcon)?[_c('i',{class:`${_vm.validIcon}`})]:[_c('v-icon',{attrs:{"color":_vm.color}},[_vm._v(" "+_vm._s(_vm.validIcon)+" ")])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }